import "../css/Menu.css";

export default function Menu(data){
    return(
        <>
        <div className="languajes_container">
        <div className="languajes_title">{data.title}</div>
        
            <a href={data.link1} className="languajes_option">{data.option1}</a>
            <a href={data.link2} className="languajes_option">{data.option2}</a>
            <a href={data.link3} className="languajes_option">{data.option3}</a>
            <a href={data.link4} className="languajes_option">{data.option4}</a>
        </div>
        </>
    )
}